<ng-container *ngIf="relatedEventData$ | async as relatedEventData">
  <!-- ORGANIZER -->
  <app-related-user-row
    [label]="'Organizer' | translate"
    [users]="relatedEventData.organizers"
  ></app-related-user-row>

  <!-- ATTENDEE -->
  <app-related-user-row
    [label]="'Attendee' | translate"
    [users]="relatedEventData.attendees"
  ></app-related-user-row>

  <!-- EVENT -->
  <app-related-link-row
    [label]="'Event' | translate"
    [iconConfig]="eventIcon"
    [text]="relatedEventData.link.text"
    [url]="relatedEventData.link.url"
    dataName="alerts-related-event-link"
  ></app-related-link-row>
</ng-container>
